import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../../APIHelpers/Responses";

export const blogPostServices = {
  addNewBlogPost,
  updatedBlogPost,
  softDeleteRestoreBlogPost,
  deleteBlogPost,
  getBlogPostList,
  getSingleBlogPost
};

// Add New Blog Post
async function addNewBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogPost`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Blog Post
async function updatedBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogPost`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Blog Post
async function softDeleteRestoreBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogPost`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Blog Post
async function deleteBlogPost(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogPost`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Blog Post
async function getBlogPostList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogPostList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogPostList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Blog Post
async function getSingleBlogPost(postId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleBlogPost/${postId}`,
      headersWithAuthWithoutBody("GET", headers)
    )
  const data = await response.json();
  return data;
}